import {ExternalLayer} from '@appscience/layers'
import {XIcon} from '@heroicons/react/outline'
import {Button, Paper, createStyles} from '@mantine/core'
import React from 'react'
import {joinStrings, mode, i18n_get_TODO} from '@appscience/utils'
import {DefaultButtonsProps, PopupDefaultContentProps, PopupDefaultProps} from './types'

/**
 * @description Если модальное окно должно открывать ещё одно, то второе окно должно быть обязательно вложено в первое
 * @description Устаревший способ. Используй useModal
 */
export const PopupDefault = React.memo(({
  show,
  onOverlayClick,
  ...contentProps
}: PopupDefaultProps) => (
  <ExternalLayer
    show={show}
    createContent={() => <PopupDefaultContent {...contentProps} />}
    onOverlayClick={onOverlayClick}
  />
))

export function getPopupDefaultButtons({ success, cancel }: DefaultButtonsProps): Array<JSX.Element> {
  const buttons: Array<JSX.Element> = []
  !!cancel && buttons.push(
    <Button key='cancel' className='font-semibold' variant='outline' onClick={cancel.onClick} disabled={cancel.disabled || success.loading}>
      {cancel.text || i18n_get_TODO('Cancel')}
    </Button>,
  )
  buttons.push(
    <Button key='success' className='font-semibold' variant='filled' onClick={success.onClick} disabled={success.disabled} loading={success.loading}>
      {success.text || i18n_get_TODO('Save')}
    </Button>,
  )
  return buttons
}


const useStyles = createStyles(({colors, colorScheme}) => ({
  container: {
    color: mode(colors.gray[7], colors.gray[7])(colorScheme),
  },
}))

export function PopupDefaultContent({
  title,
  createContent,
  buttonsInfo,
  className,
  closeFn,
}: PopupDefaultContentProps) {
  const showHeader = !!title || !!closeFn
  const buttons = buttonsInfo
    ? Array.isArray(buttonsInfo) ? buttonsInfo : getPopupDefaultButtons(buttonsInfo)
    : null
  const { classes } = useStyles()

  return (
    <Paper className={joinStrings(
      'flex flex-col p-6 my-8 text-left align-middle transition-all transform shadow-xl rounded-xl',
      classes.container,
      className,
    )}>
      {showHeader &&
        <div className='flex items-center mb-4'>
          {!!title && <h3 className='text-2xl font-bold leading-6 m-0'>{title}</h3>}
          {!!closeFn && <XIcon onClick={closeFn} className={joinStrings(
            'w-6 h-6 ml-auto mt-0.5',
            'duration-300 cursor-pointer',
          )}/>}
        </div>
      }
      {createContent()}
      {buttons && !!buttons.length && <div className='flex justify-end mt-4 space-x-2'>{buttons}</div>}
    </Paper>
  )
}
